import { Select } from '@finn-no/troika-react-select';
import React, { useState } from 'react';

type VerticalSelectorProps = {
    verticalStr: string;
    verticalVal: string;
    product: string;
    handleVerticalClick: (e: any) => void;
    url: string;
};

const VerticalSelector: React.FC<VerticalSelectorProps> = (props) => {
    const {
        verticalStr,
        verticalVal,
        product,
        handleVerticalClick,
        url,
    } = props;
    const recList = [
        {
            vertical: product,
            name: 'Alle',
        },
        {
            vertical: 'bap',
            name: 'Torget',
        },
        {
            vertical: 'realestate',
            name: 'Eiendom',
        },
        {
            vertical: 'job',
            name: 'Jobb',
        },
        {
            vertical: 'car',
            name: 'Bil',
        },
        {
            vertical: 'mc',
            name: 'MC',
        },
        {
            vertical: 'boat',
            name: 'Båt',
        },
    ];

    const [currentVertical, setCurrentVertical] = useState(
        verticalStr.length ? verticalVal : product
    );

    const trackClickOnVerticalPicker = () => {
        try {
            fetch(
                `${url}/tracking/verticalpicker/click?ts=${new Date().getTime()}`
            );
        } catch (error) {}
    };

    const trackSelectedVerticalInPicker = (e) => {
        const item = e.target[e.target.selectedIndex].text.toLowerCase();
        try {
            fetch(
                `${url}/tracking/verticalpicker/selectedvertical/${item}?ts=${new Date().getTime()}`
            );
        } catch (error) {}
    };

    return (
        <div className="grid__unit u-text-right recommendation-vertical-picker-wrapper">
            <Select
                value={currentVertical}
                onChange={(e) => {
                    e.persist();
                    setCurrentVertical(e.target.value);
                    trackSelectedVerticalInPicker(e);
                    handleVerticalClick(e);
                }}
                onFocus={trackClickOnVerticalPicker}
                label="Velg marked"
                helpText="Velg anbefalinger fra et marked"
            >
                <>
                    {recList.map((item, i) => (
                        <option
                            value={item.vertical.toString().toLowerCase()}
                            key={i}
                        >
                            {item.name.toString()}
                        </option>
                    ))}
                </>
            </Select>
        </div>
    );
};
export default VerticalSelector;
